export const enum Constants {
  TABLE_ROW_HEIGHT = 38,
}
